/**
 * Utility functions for AWS Cognito integration
 */

import { CognitoUser } from '../services/cognitoService';

/**
 * Get Cognito user ID as number (already a number)
 */
export const getUserIdAsNumber = (user: CognitoUser | null): number => {
  if (!user || !user.id) {
    return 0;
  }
  
  // ID is already a number
  return user.id;
};

/**
 * Get user role with fallback
 */
export const getUserRole = (user: CognitoUser | null): string => {
  return user?.role || 'user';
};

/** Slugs stored on leads and used by the app switcher; anything else (e.g. legacy "Admin") maps to a safe default. */
export type AppBusinessArea = 'telecommunications' | 'energy_solutions';

export function coerceAppBusinessArea(value: string | null | undefined): AppBusinessArea {
  const v = (value || '').trim();
  if (v === 'telecommunications' || v === 'energy_solutions') return v;
  return 'telecommunications';
}

/**
 * Get user business area with fallback (always a valid app slug).
 */
export const getUserBusinessArea = (user: CognitoUser | null): string => {
  return coerceAppBusinessArea(user?.business_area);
};

/**
 * Check if user has a valid role
 */
export const hasValidRole = (user: CognitoUser | null): boolean => {
  return !!(user?.role && user.role.trim() !== '');
};
